import client from '../../../utils/api'
import { createApiAction } from '../../../utils/redux-tool'

const basePath = '/api/student/:memberId/address-change'

export const search = createApiAction('academic/parent/address-change/search', client.search(basePath))
export const options = createApiAction('academic/parent/address-change/options', client.search(`/api/student/relatives`))
export const retrieve = createApiAction('academic/parent/address-change/get', client.retrieve(`${basePath}/:id`))
export const create = createApiAction('academic/parent/address-change/create', client.create(basePath))
export const update = createApiAction('academic/parent/address-change/update', client.update(`${basePath}/:id`))
export const cancel = createApiAction('academic/parent/address-change/cancel', client.create(`${basePath}/:id/cancel`))
